import { z } from 'zod';

type Params = {
  src: string;
  width: 100 | 200 | 300 | 600;
};

const IMAGE_TRANSFORMATION_ORIGIN = z
  .string()
  .parse(process.env.PUBLIC_IMAGE_TRANSFORMATION_ORIGIN);

function getImageDpiPath(src: string, width: number, dpi: number) {
  // If there is no transform origin, just load the image
  // This is probably a local env
  // We should probably add handling for this in the dev server
  if (IMAGE_TRANSFORMATION_ORIGIN === '') {
    return src;
  }

  return `${IMAGE_TRANSFORMATION_ORIGIN}/cdn-cgi/image/width=${
    width * dpi
  },dpi=${dpi}/${src}`;
}

export function getImageProps({ src, width }: Params) {
  return {
    src: getImageDpiPath(src, width, 1),
    srcSet: `${getImageDpiPath(src, width, 2)} 2x`,
    width,
    loading: 'lazy',
    decoding: 'async',
  } as const;
}
